const multipleData = {
  '要闻': {
  },
  '政务': {
  }
}
export default multipleData



// WEBPACK FOOTER //
// ./src/layout/common/config/news.js